<header class="app-header-background error-page primary-bg pb-40">
  <div class="app-header-section">

    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="start center">

      <div fxFlex="0 1" fxFlex.lt-sm="100%">

        <div class="app-header-headline">
          <h1 class="mat-h1"> Error {{ errorCode }}: </h1>
          <ng-container [ngSwitch]="errorCode">
            <h2 *ngSwitchCase="404"> We haven't found what you are looking for. </h2>
            <h2 *ngSwitchDefault>An unexpected error occurred. Please contact us.</h2>
          </ng-container>
        </div>
        <div class="app-header-start">
          <a class="app-button mat-raised-button" mat-raised-button="" tabindex="0" aria-disabled="false"
            href="https://www.sitecreator.io" target="_blank" rel="noopener">
            <span class="mat-button-wrapper"> Back to SiteCreator.io </span>
          </a>
        </div>


      </div>


      <div fxFlex="0 1" fxFlex.lt-sm="100%">

        <div class="feature-image">
          <div class="feature-image-inner">
            <ng-container [ngSwitch]="errorCode">
              <ng-container *ngSwitchCase="404">
                <img style="width: 100%;
                height: auto;
                max-width: 500px;
                margin: 20px;" class="error-img"
                  src="https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/error-404.png">
              </ng-container>
              <!-- 
              <ng-container *ngSwitchDefault>
                </ng-container>-->
            </ng-container>
          </div>
        </div>
      </div>

    </div>


  </div>
</header>